{
  "id": "binschstro",
  "title": "Binnenschifffahrtsstraßen-Ordnung, Kapitel 3: Bezeichnung der Fahrzeuge, Kapitel 4 § 4.01 bis § 4.04: Schallzeichen, und Anlage 6: Schallzeichen",
  "url": "https://www.gesetze-im-internet.de/binschstro_2012/",
  "retrieved": "2026-09-21",
  "license": "Normtext, amtliches Werk nach § 5 Absatz 1 UrhG, gemeinfrei. Übernommen wurde nur der Normtext, nicht die Aufbereitung des Anbieters.",
  "paragraphs": {
    "3.01": {
      "nummer": "3.01",
      "titel": "Begriffsbestimmungen und Anwendungen",
      "bilder": [
        "Bild 1"
      ],
      "absaetze": [
        {
          "id": "1",
          "text": "In diesem Kapitel gelten als",
          "teile": [
            {
              "id": "a",
              "text": "„Topplicht“: ein weißes starkes Licht, das über einen Horizontbogen von 225° und zwar von Voraus bis beiderseits 22°30’ hinter die Querlinie, und das nur in diesem Bogen sichtbar ist;"
            },
            {
              "id": "b",
              "text": "„Seitenlichter“: an Steuerbord ein grünes helles Licht und an Backbord ein rotes helles Licht, von denen jedes über einen Horizontbogen von 112°30’, das heißt von Voraus bis 22°30’ hinter die Querlinie auf der Seite, auf der das Licht angebracht ist, und nur in diesem Bogen sichtbar ist;"
            },
            {
              "id": "c",
              "text": "„Hecklicht“: ein weißes gewöhnliches Licht oder ein weißes helles Licht, das über einen Horizontbogen von 135°, und zwar 67°30’ von Achteraus nach jeder Seite und nur in diesem Bogen sichtbar ist;"
            },
            {
              "id": "d",
              "text": "„von allen Seiten sichtbares Licht“: ein Licht, das über einen Horizontbogen von 360° sichtbar ist."
            }
          ]
        },
        {
          "id": "2",
          "text": "Wenn es die Sichtverhältnisse erfordern, müssen die für die Nacht vorgeschriebenen Lichter zusätzlich bei Tag gesetzt werden.",
          "teile": []
        },
        {
          "id": "3",
          "text": "Bei Anwendung dieses Kapitels gilt ein Schubverband, dessen Länge 110,00 m und dessen Breite 12,00 m nicht überschreiten, als ein einzeln fahrendes Fahrzeug mit Maschinenantrieb von gleicher Länge und Breite und ein Verband gekuppelter Fahrzeuge, dessen Länge 140,00 m überschreitet, als ein Schubverband von gleicher Länge.",
          "teile": []
        },
        {
          "id": "4",
          "text": "Ein auf Schleusung wartendes Fahrzeug, das stillliegt, kann die für die Fahrt vorgeschriebene Bezeichnung beibehalten.",
          "teile": []
        },
        {
          "id": "5",
          "text": "Die in diesem Kapitel vorgeschriebenen Bezeichnungen sind in Anlage 3 abgebildet.",
          "teile": []
        }
      ]
    },
    "3.02": {
      "nummer": "3.02",
      "titel": "Lichter und Signalleuchten",
      "bilder": [],
      "absaetze": [
        {
          "id": "1",
          "text": "Soweit nichts anderes bestimmt ist, müssen die in dieser Verordnung vorgeschriebenen Lichter von allen Seiten sichtbar sein und ein gleichmäßiges, ununterbrochenes Licht werfen.",
          "teile": []
        },
        {
          "id": "2",
          "text": "Es dürfen nur Signalleuchten verwendet werden, deren Lichter in horizontaler Ausstrahlung, Farbe und Stärke den Bestimmungen dieser Verordnung und den Anforderungen des Artikels 7.05 ES-TRIN entsprechen. Signalleuchten, die den Anforderungen der am 30. Juni 2011 oder am 31. Dezember 2012 oder am 6. Oktober 2018 geltenden Fassung der Binnenschifffahrtsstraßen-Ordnung entsprechen, dürfen weiterhin verwendet werden.",
          "teile": []
        },
        {
          "id": "3",
          "text": "Die Nachtbezeichnung eines stillliegenden nicht motorisierten Fahrzeugs braucht nicht den Anforderungen der Nummer 2 zu entsprechen; sie muss jedoch bei klarer Sicht und dunklem Hintergrund eine Tragweite von mindestens 1 000,00 m haben.",
          "teile": []
        }
      ]
    },
    "3.03": {
      "nummer": "3.03",
      "titel": "Flaggen, Tafeln und Wimpel",
      "bilder": [],
      "absaetze": [
        {
          "id": "1",
          "text": "Soweit nichts anderes bestimmt ist, muss eine in dieser Verordnung vorgeschriebene Flagge oder Tafel rechteckig sein.",
          "teile": []
        },
        {
          "id": "2",
          "text": "Die Farben einer Flagge, einer Tafel oder eines Wimpels dürfen weder verblasst noch verschmutzt sein.",
          "teile": []
        },
        {
          "id": "3",
          "text": "Die Abmessungen der Sichtzeichen nach Nummer 2 müssen so groß sein, dass sie gut gesehen werden können; diese Voraussetzung gilt in jedem Falle als erfüllt",
          "teile": [
            {
              "id": "a",
              "text": "bei einer Flagge oder Tafel, wenn sie mindestens 1,00 m hoch und 1,00 m breit, bei Kleinfahrzeugen mindestens 0,60 m hoch und 0,60 m breit ist,"
            },
            {
              "id": "b",
              "text": "bei einem Wimpel, wenn seine Länge mindestens 1,00 m und seine Breite an der Seite, an der der Wimpel befestigt ist, mindestens 0,50 m beträgt."
            }
          ]
        }
      ]
    },
    "3.04": {
      "nummer": "3.04",
      "titel": "Zylinder, Bälle und Kegel",
      "bilder": [],
      "absaetze": [
        {
          "id": "1",
          "text": "Ein in dieser Verordnung vorgeschriebener Zylinder, Ball oder Kegel darf durch Einrichtungen ersetzt werden, die aus der Entfernung das gleiche Aussehen haben.",
          "teile": []
        },
        {
          "id": "2",
          "text": "Die Farben der Sichtzeichen nach Nummer 1 dürfen weder verblasst noch verschmutzt sein.",
          "teile": []
        },
        {
          "id": "3",
          "text": "Die Abmessungen der Sichtzeichen nach Nummer 1 müssen mindestens betragen:",
          "teile": [
            {
              "id": "a",
              "text": "für einen Zylinder 0,80 m in der Höhe und 0,50 m im Durchmesser;"
            },
            {
              "id": "b",
              "text": "für einen Ball 0,60 m im Durchmesser;"
            },
            {
              "id": "c",
              "text": "für einen Kegel 0,60 m in der Höhe und 0,60 m im Durchmesser der Grundfläche;"
            },
            {
              "id": "d",
              "text": "für einen Doppelkegel 0,80 m in der Höhe und 0,50 m im Durchmesser der Grundfläche."
            }
          ]
        },
        {
          "id": "4",
          "text": "Für ein Kleinfahrzeug dürfen entgegen Nummer 3 Sichtzeichen mit geringeren Abmessungen, die im Verhältnis zur Größe des Kleinfahrzeugs angemessen sind, verwendet werden. Sie müssen jedoch so groß sein, dass sie gut gesehen werden können.",
          "teile": []
        }
      ]
    },
    "3.05": {
      "nummer": "3.05",
      "titel": "Verbotene oder ausnahmsweise zugelassene Lichter und Sichtzeichen",
      "bilder": [],
      "absaetze": [
        {
          "id": "1",
          "text": "Es ist verboten, andere als die in dieser Verordnung vorgesehenen Lichter oder Sichtzeichen zu gebrauchen oder Lichter oder Sichtzeichen unter Umständen zu gebrauchen, für die sie nicht vorgeschrieben oder zugelassen sind.",
          "teile": []
        },
        {
          "id": "2",
          "text": "Zur Verständigung von Fahrzeug zu Fahrzeug oder zwischen Fahrzeug und Land dürfen jedoch auch andere Lichter oder Sichtzeichen verwendet werden, sofern dies zu keiner Verwechslung mit den in dieser Verordnung vorgesehenen Lichtern oder Sichtzeichen führen kann.",
          "teile": []
        }
      ]
    },
    "3.06": {
      "nummer": "3.06",
      "titel": "",
      "bilder": [],
      "absaetze": [
        {
          "id": "1",
          "text": "(ohne Inhalt)",
          "teile": []
        }
      ],
      "leer": true
    },
    "3.07": {
      "nummer": "3.07",
      "titel": "Verbotener Gebrauch von Lichtern, Scheinwerfern, Sichtzeichen und anderen Gegenständen",
      "bilder": [],
      "absaetze": [
        {
          "id": "1",
          "text": "Es ist verboten, ein Licht, einen Schweinwerfer, ein Sichtzeichen oder einen anderen Gegenstand in einer Weise zu gebrauchen, dass es oder er mit den in dieser Verordnung vorgesehenen Bezeichnungen verwechselt werden kann, deren Sichtbarkeit beeinträchtigt oder deren Erkennbarkeit erschweren kann.",
          "teile": []
        },
        {
          "id": "2",
          "text": "Es ist verboten, ein Licht oder einen Scheinwerfer in einer Weise zu gebrauchen, dass es oder er blendet und dadurch die Schifffahrt oder den Verkehr an Land gefährdet oder behindert.",
          "teile": []
        }
      ]
    },
    "3.08": {
      "nummer": "3.08",
      "titel": "Bezeichnung einzeln fahrender Fahrzeuge mit Maschinenantrieb",
      "bilder": [
        "Bild 2",
        "3"
      ],
      "absaetze": [
        {
          "id": "1",
          "text": "Ein einzeln fahrendes Fahrzeug mit Maschinenantrieb muss bei Nacht führen:",
          "teile": [
            {
              "id": "a",
              "text": "ein Topplicht, das auf dem vorderen Teil des Fahrzeugs gesetzt werden muss;"
            },
            {
              "id": "b",
              "text": "die Seitenlichter, die in gleicher Höhe und in einer Ebene senkrecht zur Längsebene des Fahrzeugs gesetzt werden müssen. Bei Fahrten auf Flüssen müssen die Seitenlichter mindestens 1,00 m tiefer als das Topplicht gesetzt werden. Bei Fahrten auf Kanälen müssen die Seitenlichter nach Möglichkeit 1,00 m tiefer als das Topplicht, sie dürfen jedoch nicht höher als dieses gesetzt werden. Sie müssen mindestens 1,00 m hinter dem Topplicht gesetzt und binnenbords derart abgeblendet werden, dass das grüne Licht nicht von Backbord, das rote Licht nicht von Steuerbord gesehen werden kann;"
            },
            {
              "id": "c",
              "text": "ein Hecklicht auf dem Achterschiff."
            }
          ]
        },
        {
          "id": "2",
          "text": "Ein einzeln fahrendes Fahrzeug mit Maschinenantrieb mit mehr als 110,00 m Länge muss bei Nacht außerdem ein zweites Topplicht führen und zwar auf dem Achterschiff und in größerer Höhe als das vordere Licht.",
          "teile": []
        },
        {
          "id": "3",
          "text": "Das Fahrzeug mit Maschinenantrieb muss die Lichter nach Nummer 1 und 2 auch dann führen, wenn ihm bei Nacht vorübergehend auf kurzer Strecke ein Vorspann vorausfährt; der Vorspann muss die Lichter nach § 3.09 Nummer 1 Buchstabe a Satz 1 führen.",
          "teile": []
        },
        {
          "id": "4",
          "text": "Das Fahrzeug mit Maschinenantrieb muss die Bezeichnung nach § 3.09 Nummer 3 Satz 1 Buchstabe b führen, wenn ihm bei Tag vorübergehend auf einer kurzen Strecke ein Vorspann vorausfährt; der Vorspann muss die Bezeichnung nach § 3.09 Nummer 1 Buchstabe b Satz 1 führen.",
          "teile": []
        },
        {
          "id": "5",
          "text": "Die Nummern 1 bis 4 gelten nicht für ein Kleinfahrzeug oder für eine Fähre; für ein Kleinfahrzeug gilt § 3.13, für eine Fähre § 3.16.",
          "teile": []
        }
      ]
    },
    "3.09": {
      "nummer": "3.09",
      "titel": "Bezeichnung der Schleppverbände in Fahrt",
      "bilder": [
        "Bild 4",
        "5",
        "6",
        "7",
        "8",
        "9",
        "10"
      ],
      "absaetze": [
        {
          "id": "1",
          "text": "An der Spitze eines Schleppverbandes in Fahrt muss das Fahrzeug mit Maschinenantrieb führen:",
          "teile": [
            {
              "id": "a",
              "text": "bei Nacht: aa) außer dem Topplicht und den Seitenlichtern nach § 3.08 Nummer 1 Buchstabe a und b ein zweites Topplicht; dieses muss etwa 1,00 m unter dem ersten Topplicht, jedoch nach Möglichkeit mindestens 1,00 m höher als die Seitenlichter gesetzt werden; bb) statt des Hecklichts nach § 3.08 Nummer 1 Buchstabe c ein gelbes Hecklicht an geeigneter Stelle und in ausreichender Höhe, damit es von dem nachfolgenden Anhang gesehen werden kann. Das Fahrzeug muss diese Lichter auch dann führen, wenn ihm vorübergehend auf kurzer Strecke ein Vorspann vorausfährt; der Vorspann muss die Lichter führen, die das geschleppte Fahrzeug führen muss."
            },
            {
              "id": "b",
              "text": "bei Tag: einen gelben Zylinder, der oben und unten mit je einem schwarzen und je einem weißen Streifen – letztere an den äußeren Enden – eingefasst ist; der Zylinder muss auf dem Vorschiff senkrecht und so hoch gesetzt werden, dass er von allen Seiten sichtbar ist. 4 Das Fahrzeug muss den Zylinder auch dann führen, wenn ihm vorübergehend auf einer kurzen Strecke ein Vorspann vorausfährt; der Vorspann muss den Zylinder ebenfalls führen."
            }
          ]
        },
        {
          "id": "2",
          "text": "Hat ein Schleppverband an der Spitze mehrere Fahrzeuge mit Maschinenantrieb, die nebeneinander fahren, sei es längsseits gekuppelt oder nicht, muss jedes dieser Fahrzeuge führen: Das Gleiche gilt für alle Fahrzeuge mit Maschinenantrieb, die gemeinsam ein Fahrzeug, einen Schwimmkörper oder eine schwimmende Anlage bugsieren.",
          "teile": [
            {
              "id": "a",
              "text": "bei Nacht: ein drittes Topplicht; dieses muss etwa 2,00 m unter dem ersten Topplicht, jedoch nach Möglichkeit mindestens 1,00 m höher als die Seitenlichter gesetzt werden;"
            },
            {
              "id": "b",
              "text": "bei Tag: den Zylinder nach Nummer 1 Buchstabe b."
            }
          ]
        },
        {
          "id": "3",
          "text": "Die geschleppten Fahrzeuge eines Schleppverbandes in Fahrt müssen führen: Das Gleiche gilt für geschleppte Schwimmkörper oder geschleppte schwimmende Anlagen. Wenn jedoch Die Lichter und Bälle aller geschleppten Fahrzeuge eines Verbandes sind so zu setzen, dass sie sich möglichst in gleicher Höhe über dem Wasserspiegel befinden.",
          "teile": [
            {
              "id": "a",
              "text": "bei Nacht: ein weißes helles, von allen Seiten sichtbares Licht;"
            },
            {
              "id": "b",
              "text": "bei Tag: einen gelben Ball an einer geeigneten Stelle und so hoch, dass er von allen Seiten sichtbar ist."
            },
            {
              "id": "a.2",
              "text": "eine Anhanglänge des Verbandes 110,00 m überschreitet, muss sie bei Nacht zwei Lichter nach Satz 1 führen, und zwar eines auf der vorderen und eines auf der hinteren Hälfte des Fahrzeugs;"
            },
            {
              "id": "b.2",
              "text": "eine Anhanglänge des Verbandes aus mehr als zwei längsseits verbundenen Fahrzeugen besteht, sind die Lichter oder die Bälle nach Satz 1 nur von den beiden äußeren Fahrzeugen zu führen."
            }
          ]
        },
        {
          "id": "4",
          "text": "Das Fahrzeug oder die Fahrzeuge, die die letzte Anhanglänge eines Schleppverbandes in Fahrt bilden, müssen bei Nacht führen: Bilden ein oder mehrere Kleinfahrzeuge den Schluss eines Verbandes, bleiben sie bei Anwendung der Vorschriften dieser Nummer unberücksichtigt.",
          "teile": [
            {
              "id": "a",
              "text": "das Licht nach Nummer 3 oder das Topplicht nach § 3.08 Nummer 1 Buchstabe a;"
            },
            {
              "id": "b",
              "text": "das Hecklicht nach § 3.08 Nummer 1 Buchstabe c; bilden mehr als zwei längsseits verbundene Fahrzeuge den Schluss des Verbandes, brauchen nur die beiden äußeren Fahrzeuge dieses Licht zu führen."
            }
          ]
        },
        {
          "id": "5",
          "text": "Auf einer Reede braucht ein Schleppverband, der aus einem Fahrzeug mit Maschinenantrieb und einer einzigen Anhanglänge besteht, die Tagbezeichnung nach den Nummern 1 bis 4 nicht zu führen.",
          "teile": []
        },
        {
          "id": "6",
          "text": "Die Nummern 1 bis 5 gelten nicht für ein Kleinfahrzeug, das ausschließlich Kleinfahrzeuge schleppt, und nicht für ein geschlepptes Kleinfahrzeug. Für derartige Kleinfahrzeuge gilt § 3.13 Nummer 2 und 3.",
          "teile": []
        }
      ]
    },
    "3.10": {
      "nummer": "3.10",
      "titel": "Bezeichnung der Schubverbände in Fahrt",
      "bilder": [
        "Bild 11",
        "12",
        "13",
        "14"
      ],
      "absaetze": [
        {
          "id": "1",
          "text": "Ein Schubverband in Fahrt muss bei Nacht führen:",
          "teile": [
            {
              "id": "a",
              "text": "als Topplichter aa) drei Topplichter auf dem Vorschiff des Fahrzeugs oder, bei mehreren Fahrzeugen, auf dem Vorschiff des linken der Fahrzeuge an der Spitze des Verbandes; diese Topplichter müssen in der Form eines gleichseitigen Dreiecks mit waagerechter Grundlinie in einer Ebene senkrecht zur Längsebene des Verbandes angeordnet sein; die beiden unteren Topplichter müssen in einem Abstand von 1,25 m voneinander und 1,10 m unter dem obersten Topplicht gesetzt werden; sie müssen darüber hinaus auf einem Fluss mindestens 2,00 m über der Ebene der Einsenkungsmarken und mindestens 1,00 m über den Seitenlichtern, auf einem Schifffahrtskanal oder in einem Schleusenkanal so hoch wie möglich, jedoch mindestens in Höhe der Seitenlichter gesetzt werden; bb) ein Topplicht auf dem Vorschiff jedes anderen Fahrzeugs, dessen ganze Breite von vorn sichtbar ist; dieses Topplicht ist nach Möglichkeit 3,00 m tiefer als das oberste Topplicht nach Doppelbuchstabe aa hiervor zu setzen. Die Masten dieser Topplichter müssen in der Längsebene des Fahrzeugs stehen, auf dem sie geführt werden;"
            },
            {
              "id": "b",
              "text": "Seitenlichter so weit wie möglich hinten am breitesten Teil des Schubverbandes, höchstens 1,00 m von den Außenseiten des Schubverbandes entfernt und mindestens 2,00 m über dem Wasserspiegel;"
            },
            {
              "id": "c",
              "text": "als Hecklichter aa) drei Hecklichter auf dem Achterschiff des schiebenden Fahrzeugs in einer waagerechten Linie senkrecht zur Längsebene mit einem seitlichen Abstand von etwa 1,25 m und in ausreichender Höhe, sodass sie nicht durch eines der anderen Fahrzeuge des Verbandes verdeckt werden können; bb) ein Hecklicht auf dem Achterschiff eines jeden anderen Fahrzeugs, dessen ganze Breite von hinten sichtbar ist; befinden sich in dem Verband außer dem schiebenden Fahrzeug mehr als zwei von hinten sichtbare Fahrzeuge, ist dieses Hecklicht nur von den beiden äußeren Fahrzeugen zu führen."
            }
          ]
        },
        {
          "id": "2",
          "text": "Ein Schubverband, der durch zwei schiebende Fahrzeuge nebeneinander fortbewegt wird, muss bei Nacht Hecklichter nach Nummer 1 Buchstabe c Doppelbuchstabe aa auf dem steuerbordseitigen schiebenden Fahrzeug führen, das andere schiebende Fahrzeug muss das Hecklicht nach Nummer 1 Buchstabe c Doppelbuchstabe bb führen.",
          "teile": []
        },
        {
          "id": "3",
          "text": "Nummer 1 gilt auch für einen Schubverband, wenn er bei Nacht geschleppt wird; jedoch müssen die drei Hecklichter nach Nummer 1 Buchstabe c Doppelbuchstabe aa gelb sein.",
          "teile": []
        },
        {
          "id": "4",
          "text": "Wird ein Schubverband bei Tag geschleppt, muss das schiebende Fahrzeug führen: einen gelben Ball an einer geeigneten Stelle und so hoch, dass er von allen Seiten sichtbar ist.",
          "teile": []
        }
      ]
    },
    "3.11": {
      "nummer": "3.11",
      "titel": "Bezeichnung gekuppelter Fahrzeuge in Fahrt",
      "bilder": [
        "Bild 15",
        "16"
      ],
      "absaetze": [
        {
          "id": "1",
          "text": "Gekuppelte Fahrzeuge in Fahrt müssen bei Nacht führen:",
          "teile": [
            {
              "id": "a",
              "text": "auf jedem Fahrzeug das Topplicht nach § 3.08 Nummer 1 Buchstabe a; auf Fahrzeugen ohne Maschinenantrieb kann dieses Topplicht jedoch an einer geeigneten Stelle und nicht höher als das Topplicht des Fahrzeugs oder der Fahrzeuge mit Maschinenantrieb durch das Licht nach § 3.09 Nummer 3 ersetzt werden;"
            },
            {
              "id": "b",
              "text": "die Seitenlichter nach § 3.08 Nummer 1 Buchstabe b; diese Lichter müssen an der Außenseite der äußeren Fahrzeuge gesetzt werden, und zwar möglichst in gleicher Höhe und mindestens 1,00 m tiefer als das niedrigste Topplicht;"
            },
            {
              "id": "c",
              "text": "auf jedem Fahrzeug ein Hecklicht nach § 3.08 Nummer 1 Buchstabe c."
            }
          ]
        },
        {
          "id": "2",
          "text": "Die gekuppelten Fahrzeuge müssen die Lichter nach Nummer 1 auch dann führen, wenn ihnen vorübergehend auf kurzer Strecke ein Vorspann vorausfährt; der Vorspann muss die Lichter nach § 3.09 Nummer 1 Buchstabe a Satz 1 führen.",
          "teile": []
        },
        {
          "id": "3",
          "text": "Jedes gekuppelte Fahrzeug muss die Bezeichnung nach § 3.09 Nummer 3 Satz 1 Buchstabe b führen, wenn ihm bei Tag vorübergehend auf einer kurzen Strecke ein Vorspann vorausfährt; der Vorspann muss die Bezeichnung nach § 3.09 Nummer 1 Buchstabe b Satz 1 führen.",
          "teile": []
        },
        {
          "id": "4",
          "text": "Nummer 1, auch in Verbindung mit Nummer 2, und Nummer 3 gelten nicht für ein Kleinfahrzeug, das nur Kleinfahrzeuge längsseits gekuppelt führt, und nicht für ein längsseits gekuppeltes Kleinfahrzeug. Für ein Kleinfahrzeug nach Satz 1 gilt § 3.13 Nummer 2 und 3.",
          "teile": []
        }
      ]
    },
    "3.12": {
      "nummer": "3.12",
      "titel": "Bezeichnung der Fahrzeuge unter Segel in Fahrt",
      "bilder": [
        "Bild 17"
      ],
      "absaetze": [
        {
          "id": "1",
          "text": "Ein Fahrzeug unter Segel in Fahrt muss bei Nacht führen:",
          "teile": [
            {
              "id": "a",
              "text": "die Seitenlichter nach § 3.08 Nummer 1 Buchstabe b, jedoch können diese gewöhnliche Lichter sein;"
            },
            {
              "id": "b",
              "text": "ein Hecklicht nach § 3.08 Nummer 1 Buchstabe c."
            }
          ]
        },
        {
          "id": "2",
          "text": "Nummer 1 gilt nicht für ein Kleinfahrzeug; für ein Kleinfahrzeug unter Segel in Fahrt gilt § 3.13 Nummer 4 und 6.",
          "teile": []
        }
      ]
    },
    "3.13": {
      "nummer": "3.13",
      "titel": "Bezeichnung der Kleinfahrzeuge in Fahrt",
      "bilder": [
        "Bild 18",
        "19",
        "20",
        "21",
        "22",
        "23",
        "24",
        "25",
        "26"
      ],
      "absaetze": [
        {
          "id": "1",
          "text": "Ein einzeln fahrendes Kleinfahrzeug mit Maschinenantrieb muss bei Nacht führen: entweder oder",
          "teile": [
            {
              "id": "a",
              "text": "ein Topplicht, jedoch hell statt stark, in gleicher Höhe wie die Seitenlichter und mindestens 1,00 m vor diesen;"
            },
            {
              "id": "b",
              "text": "Seitenlichter, die gewöhnliche Lichter sein dürfen; sie müssen in gleicher Höhe und in einer Ebene senkrecht zur Längsachse des Fahrzeugs gesetzt sein und innenbords derart abgeblendet sein, dass das grüne Licht nicht von Backbord, das rote Licht nicht von Steuerbord gesehen werden kann;"
            },
            {
              "id": "c",
              "text": "ein Hecklicht;"
            },
            {
              "id": "d",
              "text": "ein Topplicht, jedoch hell statt stark, mindestens 1,00 m höher als die Seitenlichter;"
            },
            {
              "id": "e",
              "text": "Seitenlichter, die gewöhnliche Lichter sein dürfen; diese können aa) in gleicher Höhe und in einer Ebene senkrecht zur Längsachse des Fahrzeugs oder bb) unmittelbar nebeneinander oder in einer einzigen Laterne am oder nahe am Bug in der Schiffsachse gesetzt sein; im Falle des Doppelbuchstaben aa müssen sie innenbords derart abgeblendet sein, dass das grüne Licht nicht von Backbord, das rote Licht nicht von Steuerbord gesehen werden kann;"
            },
            {
              "id": "f",
              "text": "ein Hecklicht; dieses Licht darf unter der Voraussetzung entfallen, dass anstelle des Topplichtes nach Buchstabe d ein von allen Seiten sichtbares weißes helles Licht geführt wird."
            }
          ]
        },
        {
          "id": "2",
          "text": "Schleppt ein Kleinfahrzeug ausschließlich Kleinfahrzeuge oder führt es nur solche längsseits gekuppelt, muss es bei Nacht die Lichter nach Nummer 1 führen.",
          "teile": []
        },
        {
          "id": "3",
          "text": "Ein geschlepptes oder längsseits gekuppeltes Kleinfahrzeug muss bei Nacht ein von allen Seiten sichtbares weißes gewöhnliches Licht führen. Dies gilt nicht für die Beiboote des Fahrzeugs.",
          "teile": []
        },
        {
          "id": "4",
          "text": "Ein einzeln fahrendes Kleinfahrzeug unter Segel muss bei Nacht führen: entweder",
          "teile": [
            {
              "id": "a",
              "text": "die Seitenlichter nach Nummer 1 Buchstabe e und ein Hecklicht"
            },
            {
              "id": "b",
              "text": "diese Seitenlichter und das Hecklicht in einer einzigen Laterne am Topp"
            },
            {
              "id": "c",
              "text": "ein von allen Seiten sichtbares weißes gewöhnliches Licht und bei der Annäherung anderer Fahrzeuge außerdem ein zweites weißes gewöhnliches Licht zeigen."
            }
          ]
        },
        {
          "id": "5",
          "text": "Ein einzeln weder mit Maschinenantrieb noch unter Segel fahrendes Kleinfahrzeug muss bei Nacht ein von allen Seiten sichtbares weißes gewöhnliches Licht führen. Ein Beiboot, auf das die gleichen Voraus- setzungen zutreffen, braucht dieses Licht jedoch nur bei der Annäherung eines anderen Fahrzeugs zu zeigen.",
          "teile": []
        },
        {
          "id": "6",
          "text": "Ein Kleinfahrzeug unter Segel, das gleichzeitig mit Maschinenantrieb fährt, muss bei Tag einen schwarzen Kegel mit der Spitze nach unten, so hoch wie möglich an einer Stelle, an der er am besten sichtbar ist, führen.",
          "teile": []
        }
      ]
    },
    "3.14": {
      "nummer": "3.14",
      "titel": "Zusätzliche Bezeichnung der Fahrzeuge in Fahrt bei Beförderung bestimmter gefährlicher Güter",
      "bilder": [
        "Bild 27a",
        "27b",
        "28a",
        "28b",
        "29",
        "30",
        "31",
        "32"
      ],
      "absaetze": [
        {
          "id": "1",
          "text": "Ein Fahrzeug in Fahrt, das bestimmte entzündbare Stoffe nach Kapitel 3.2 Tabelle A des ADN befördert, muss zusätzlich zu der anderen nach dieser Verordnung vorgeschriebenen Bezeichnung folgende Bezeichnung nach den Unterabschnitten 7.1.5.0 oder 7.2.5.0 des ADN führen:",
          "teile": [
            {
              "id": "a",
              "text": "bei Nacht: ein blaues Licht;"
            },
            {
              "id": "b",
              "text": "bei Tag: einen blauen Kegel mit der Spitze nach unten."
            },
            {
              "id": "a.2",
              "text": "dem Vorschiff mindestens in einem Bereich von Backbord querab über Voraus bis Steuerbord querab,"
            },
            {
              "id": "b.2",
              "text": "auf dem Achterschiff mindestens in einem Bereich von Backbord querab über Achteraus bis Steuerbord querab"
            }
          ]
        },
        {
          "id": "2",
          "text": "Ein Fahrzeug in Fahrt, das bestimmte gesundheitsschädliche Stoffe nach Kapitel 3.2 Tabelle A des ADN befördert, muss zusätzlich zu der anderen nach dieser Verordnung vorgeschriebenen Bezeichnung folgende Bezeichnung nach Unterabschnitt 7.1.5.0 oder 7.2.5.0 des ADN führen:",
          "teile": [
            {
              "id": "a",
              "text": "bei Nacht: zwei blaue Lichter;"
            },
            {
              "id": "b",
              "text": "bei Tag: zwei blaue Kegel mit der Spitze nach unten."
            },
            {
              "id": "a.2",
              "text": "dem Vorschiff mindestens in einem Bereich von Backbord querab über Voraus bis Steuerbord querab,"
            },
            {
              "id": "b.2",
              "text": "auf dem Achterschiff mindestens in einem Bereich von Backbord querab über Achteraus bis Steuerbord querab"
            }
          ]
        },
        {
          "id": "3",
          "text": "Ein Fahrzeug in Fahrt, das bestimmte explosive Stoffe nach Kapitel 3.2 Tabelle A des ADN befördert, muss zusätzlich zu der anderen nach dieser Verordnung vorgeschriebenen Bezeichnung folgende Bezeichnung nach Unterabschnitt 7.1.5.0 oder 7.2.5.0 des ADN führen:",
          "teile": [
            {
              "id": "a",
              "text": "bei Nacht: drei blaue Lichter;"
            },
            {
              "id": "b",
              "text": "bei Tag: drei blaue Kegel mit der Spitze nach unten."
            },
            {
              "id": "a.2",
              "text": "dem Vorschiff mindestens in einem Bereich von Backbord querab über Voraus bis Steuerbord querab,"
            },
            {
              "id": "b.2",
              "text": "auf dem Achterschiff mindestens in einem Bereich von Backbord querab über Achteraus bis Steuerbord querab"
            }
          ]
        },
        {
          "id": "4",
          "text": "Fährt oder fahren in einem Schubverband oder in einer Zusammenstellung gekuppelter Fahrzeuge ein Fahrzeug oder mehrere Fahrzeuge im Sinne der Nummer 1, 2 oder 3, muss die Bezeichnung nach der Nummer 1, 2 oder 3 auf dem Fahrzeug geführt werden, das den Verband oder die Zusammenstellung fortbewegt.",
          "teile": []
        },
        {
          "id": "5",
          "text": "Ein Schubverband, der durch zwei schiebende Fahrzeuge nebeneinander fortbewegt wird, muss die Bezeichnung nach Nummer 4 auf dem steuerbordseitigen, schiebenden Fahrzeug führen.",
          "teile": []
        },
        {
          "id": "6",
          "text": "Ein Fahrzeug, ein Schubverband oder gekuppelte Fahrzeuge, das, der oder die verschiedene gefährliche Güter nach den Nummern 1, 2 oder 3 zusammen befördern, führen die Bezeichnung für das gefährliche Gut, das die größte Anzahl der blauen Lichter oder blauen Kegel erfordert.",
          "teile": []
        },
        {
          "id": "7",
          "text": "Ein Fahrzeug, das keine Bezeichnung nach Nummer 1, 2 oder 3 führen muss, jedoch nach Abschnitt 1.16.1 des ADN ein Zulassungszeugnis besitzt und die Sicherheitsbestimmungen einhält, die für ein Fahrzeug nach Nummer 1 gelten, hat bei der Annäherung an Schleusen die Bezeichnung nach Nummer 1 zu führen, wenn es zusammen mit einem Fahrzeug geschleust werden will, das die Bezeichnung nach Nummer 1 führen muss.",
          "teile": []
        },
        {
          "id": "8",
          "text": "Die Lichtstärke der in den Nummern 1 bis 7 vorgeschriebenen blauen Lichter muss mindestens derjenigen der gewöhnlichen blauen Lichter entsprechen.",
          "teile": []
        }
      ]
    },
    "3.15": {
      "nummer": "3.15",
      "titel": "Bezeichnung der Fahrzeuge in Fahrt, die zur Beförderung von mehr als zwölf Fahrgästen zugelassen sind und deren Schiffskörper eine größte Länge von weniger als 20,00 m aufweist",
      "bilder": [
        "Bild 33"
      ],
      "absaetze": [
        {
          "id": "1",
          "text": "Ein Fahrzeug, das zur Beförderung von mehr als zwölf Fahrgästen zugelassen ist und dessen Schiffskörper eine größte Länge von weniger als 20,00 m aufweist, muss in Fahrt bei Tag einen gelben Doppelkegel an einer geeigneten Stelle und so hoch, dass er von allen Seiten sichtbar ist, führen. Satz 1 gilt nicht für eine Fähre.",
          "teile": []
        }
      ]
    },
    "3.16": {
      "nummer": "3.16",
      "titel": "Bezeichnung der Fähren in Fahrt",
      "bilder": [
        "Bild 34",
        "35",
        "36"
      ],
      "absaetze": [
        {
          "id": "1",
          "text": "Eine nicht frei fahrende Fähre in Fahrt muss bei Nacht führen:",
          "teile": [
            {
              "id": "a",
              "text": "ein von allen Seiten sichtbares weißes helles Licht mindestens 5,00 m über der Ebene der Einsenkungsmarken; die Höhe darf jedoch verringert werden, wenn die Länge der Fähre 15,00 m nicht überschreitet;"
            },
            {
              "id": "b",
              "text": "ein von allen Seiten sichtbares grünes helles Licht etwa 1,00 m über dem Licht nach Buchstabe a."
            }
          ]
        },
        {
          "id": "2",
          "text": "Bei einer Gierfähre am Längsseil in Fahrt muss bei Nacht der oberste Buchtnachen oder Döpper mit einem weißen hellen Licht mindestens 3,00 m über dem Wasser versehen sein.",
          "teile": []
        },
        {
          "id": "3",
          "text": "Eine frei fahrende Fähre in Fahrt muss bei Nacht führen:",
          "teile": [
            {
              "id": "a",
              "text": "die Lichter nach Nummer 1;"
            },
            {
              "id": "b",
              "text": "die Lichter nach § 3.08 Nummer 1 Buchstabe b und c."
            }
          ]
        }
      ]
    },
    "3.17": {
      "nummer": "3.17",
      "titel": "Zusätzliche Bezeichnung der Fahrzeuge in Fahrt, die einen Vorrang besitzen",
      "bilder": [
        "Bild 37"
      ],
      "absaetze": [
        {
          "id": "1",
          "text": "Ein Fahrzeug, dem die zuständige Behörde zur Durchfahrt durch eine Stelle, an der eine bestimmte Reihenfolge gilt, einen Vorrang eingeräumt hat, muss in Fahrt außer der anderen nach dieser Verordnung vorgeschriebenen Bezeichnung bei Tag einen roten Wimpel auf dem Vorschiff und so hoch, dass er gut sichtbar ist, führen.",
          "teile": []
        }
      ]
    },
    "3.18": {
      "nummer": "3.18",
      "titel": "Zusätzliche Bezeichnung manövrierunfähiger Fahrzeuge in Fahrt",
      "bilder": [
        "Bild 38"
      ],
      "absaetze": [
        {
          "id": "1",
          "text": "Ein manövrierunfähiges Fahrzeug in Fahrt muss zusätzlich zu der anderen nach dieser Verordnung vorgeschriebenen Bezeichnung Anstelle der Bezeichnung nach Satz 1 kann das vorgeschriebene Schallzeichen gegeben werden oder beides zugleich.",
          "teile": [
            {
              "id": "a",
              "text": "bei Nacht: ein rotes Licht zeigen, das im unteren Halbkreis geschwenkt wird;"
            },
            {
              "id": "b",
              "text": "bei Tag: eine rote Flagge zeigen, die im unteren Halbkreis geschwenkt wird."
            }
          ]
        },
        {
          "id": "2",
          "text": "Die Flagge nach Nummer 1 Buchstabe b kann durch eine Tafel gleicher Farbe ersetzt werden.",
          "teile": []
        }
      ]
    },
    "3.19": {
      "nummer": "3.19",
      "titel": "Bezeichnung der Schwimmkörper und schwimmenden Anlagen in Fahrt",
      "bilder": [
        "Bild 39"
      ],
      "absaetze": [
        {
          "id": "1",
          "text": "Unbeschadet der besonderen Auflagen, die nach § 1.21 festgelegt werden können, muss ein Schwimmkörper oder eine schwimmende Anlage in Fahrt bei Nacht von allen Seiten sichtbare weiße helle Lichter in genügender Zahl, um ihre Umrisse kenntlich zu machen, führen.",
          "teile": []
        }
      ]
    },
    "3.20": {
      "nummer": "3.20",
      "titel": "Bezeichnung der Fahrzeuge beim Stillliegen",
      "bilder": [
        "Bild 40",
        "41"
      ],
      "absaetze": [
        {
          "id": "1",
          "text": "Mit Ausnahme eines Kleinfahrzeugs und der in den §§ 3.22 und 3.25 genannten Fahrzeuge muss ein Fahrzeug beim Stillliegen bei Nacht ein von allen Seiten sichtbares weißes gewöhnliches Licht auf der Fahrwasserseite mindestens 3,00 m über der Ebene der Einsenkungsmarken führen. Anstelle der Bezeichnung nach Satz 1 können auch zwei von allen Seiten sichtbare weiße gewöhnliche Lichter auf der Fahrwasserseite in gleicher Höhe auf dem Vor- und dem Achterschiff geführt werden.",
          "teile": []
        },
        {
          "id": "2",
          "text": "Ein Kleinfahrzeug – mit Ausnahme eines Beibootes – muss beim Stillliegen bei Nacht ein von allen Seiten sichtbares weißes gewöhnliches Licht auf der Fahrwasserseite führen.",
          "teile": []
        },
        {
          "id": "3",
          "text": "Die in den Nummern 1 und 2 vorgeschriebene Bezeichnung braucht nicht geführt zu werden, wenn",
          "teile": [
            {
              "id": "a",
              "text": "das Fahrzeug zu einer Zusammenstellung von Fahrzeugen gehört, die voraussichtlich nicht vor dem Ende der Nacht aufgelöst wird und die Fahrzeuge dieser Zusammenstellung auf der Fahrwasserseite das Licht nach Nummer 1 führen,"
            },
            {
              "id": "b",
              "text": "sich das Fahrzeug völlig zwischen nicht überfluteten Buhnen befindet oder hinter einem aus dem Wasser ragenden Längswerk stillliegt oder"
            },
            {
              "id": "c",
              "text": "das Fahrzeug am Ufer stillliegt und von diesem aus hinreichend beleuchtet ist."
            }
          ]
        },
        {
          "id": "4",
          "text": "Sind Fahrzeuge an einer besonders dafür ausgewiesenen Stelle zusammengezogen, kann die zuständige Behörde in Sonderfällen einen Teil von ihnen von der Lichterführung nach den Nummern 1 oder 2 befreien.",
          "teile": []
        }
      ]
    },
    "3.21": {
      "nummer": "3.21",
      "titel": "Zusätzliche Bezeichnung stillliegender Fahrzeuge bei Beförderung bestimmter gefährlicher Güter",
      "bilder": [
        "Bild 42",
        "43",
        "44"
      ],
      "absaetze": [
        {
          "id": "1",
          "text": "Die nach § 3.14 jeweils vorgeschriebene Bezeichnung ist von den dort genannten Fahrzeugen, Schubverbänden und gekuppelten Fahrzeugen auch beim Stillliegen zu führen.",
          "teile": []
        }
      ]
    },
    "3.22": {
      "nummer": "3.22",
      "titel": "Bezeichnung der Fähren, die an ihrer Anlegestelle stillliegen",
      "bilder": [
        "Bild 45",
        "46"
      ],
      "absaetze": [
        {
          "id": "1",
          "text": "Eine nicht frei fahrende Fähre muss während des Betriebes bei Nacht beim Stillliegen an ihrer Anlegestelle die Lichter nach § 3.16 Nummer 1 führen. Außerdem muss bei einer Gierseilfähre am Längsseil bei Nacht der oberste Buchtnachen oder Döpper das Licht nach § 3.16 Nummer 2 führen.",
          "teile": []
        },
        {
          "id": "2",
          "text": "Eine frei fahrende Fähre während des Betriebes bei Nacht muss beim Stillliegen an ihrer Anlegestelle die Lichter nach § 3.16 Nummer 1 führen; sie dürfen außerdem die Lichter nach § 3.08 Nummer 1 Buchstabe b und c beibehalten. Das grüne Licht nach § 3.16 Nummer 1 Buchstabe b und die Lichter nach § 3.08 Nummer 1 Buchstabe b und c müssen gelöscht werden, sobald die Fähren nicht mehr in Betrieb sind.",
          "teile": []
        }
      ]
    },
    "3.23": {
      "nummer": "3.23",
      "titel": "Bezeichnung der Schwimmkörper und schwimmenden Anlagen beim Stillliegen",
      "bilder": [
        "Bild 47"
      ],
      "absaetze": [
        {
          "id": "1",
          "text": "Unbeschadet der besonderen Bedingungen, die nach § 1.21 festgelegt werden können, muss ein Schwimmkörper oder eine schwimmende Anlage beim Stillliegen bei Nacht von allen Seiten sichtbare weiße gewöhnliche Lichter in genügender Zahl, um ihre fahrwasserseitigen Umrisse kenntlich zu machen, führen. Die in Satz 1 vorgeschriebenen Lichter brauchen nicht geführt zu werden, wenn die Voraussetzungen des § 3.20 Nummer 3 Buchstabe b oder c oder Nummer 4 erfüllt sind. Wenn durch die Lage des Schwimmkörpers oder der schwimmenden Anlage eine Behinderung des Schiffsverkehrs ausgeschlossen und dieser oder diese nicht über Gebühr durch die Schifffahrt gefährdet ist, kann die zuständige Behörde für einzelne Schwimmkörper oder schwimmende Anlagen das Stillliegen ohne Beleuchtung zulassen.",
          "teile": []
        }
      ]
    },
    "3.24": {
      "nummer": "3.24",
      "titel": "Bezeichnung bestimmter stillliegender Fischereifahrzeuge und der Netze oder Ausleger",
      "bilder": [
        "Bild 48"
      ],
      "absaetze": [
        {
          "id": "1",
          "text": "Ein Fischereifahrzeug, ein Kleinfahrzeug eingeschlossen, das seine Netze oder Ausleger im Fahrwasser oder in dessen Nähe ausgelegt hat, muss beim Stillliegen bei Nacht die Bezeichnung nach § 3.20 Nummer 1 führen.",
          "teile": []
        },
        {
          "id": "2",
          "text": "Die Netze oder Ausleger des Fahrzeugs nach Nummer 1 müssen bezeichnet sein:",
          "teile": [
            {
              "id": "a",
              "text": "bei Nacht: durch von allen Seiten sichtbare weiße gewöhnliche Lichter in ausreichender Zahl, um ihre Lage kenntlich zu machen;"
            },
            {
              "id": "b",
              "text": "bei Tag: durch gelbe Döpper oder gelbe Flaggen in ausreichender Zahl, um ihre Lage kenntlich zu machen."
            }
          ]
        },
        {
          "id": "3",
          "text": "Die zuständige Behörde kann eine von Nummer 2 Buchstabe b abweichende Bezeichnung vorschreiben oder zulassen.",
          "teile": []
        }
      ]
    },
    "3.25": {
      "nummer": "3.25",
      "titel": "Bezeichnung schwimmender Geräte bei der Arbeit sowie festgefahrener oder gesunkener Fahrzeuge",
      "bilder": [
        "Bild 49a",
        "49b",
        "50a",
        "50b",
        "51",
        "52"
      ],
      "absaetze": [
        {
          "id": "1",
          "text": "Ein schwimmendes Gerät bei der Arbeit oder ein Fahrzeug, das in der Wasserstraße Arbeiten, Peilungen oder andere Messungen ausführt und dabei stillliegt, muss führen: Wenn das in Satz 1 genannte Fahrzeug gegen Sog oder Wellenschlag geschützt werden muss, muss es führen: Die Bezeichnung nach den Sätzen 1 und 2 ist so hoch zu setzen, dass sie von allen Seiten sichtbar ist. Die Flaggen können durch Tafeln gleicher Farbe ersetzt werden.",
          "teile": [
            {
              "id": "a",
              "text": "nach der Seite oder den Seiten, an der oder denen die Durchfahrt frei ist: aa) bei Nacht: übereinander zwei grüne gewöhnliche Lichter oder zwei grüne helle Lichter; bb) bei Tag: entweder aaa) das Tafelzeichen E.1 (Anlage 7) oder bbb) zwei grüne Doppelkegel übereinander in einem Abstand von 1,00 m und gegebenenfalls"
            },
            {
              "id": "b",
              "text": "nach der Seite, an der die Durchfahrt nicht frei ist: aa) bei Nacht: ein rotes gewöhnliches Licht oder ein rotes helles Licht in gleicher Höhe und von gleicher Stärke wie das nach Buchstabe a Doppelbuchstabe aa gezeigte oberste grüne Licht; bb) bei Tag: entweder aaa) das Tafelzeichen A.1 (Anlage 7) in gleicher Höhe wie das Tafelzeichen nach Buchstabe a Doppelbuchstabe bb Dreifachbuchstabe aaa oder bbb) einen roten Ball in gleicher Höhe wie der oberste Doppelkegel nach Buchstabe a Doppelbuchstabe bb Dreifachbuchstabe bbb."
            },
            {
              "id": "a.2",
              "text": "nach der Seite oder den Seiten, an der die Durchfahrt frei ist: aa) bei Nacht: ein rotes gewöhnliches Licht und ein weißes gewöhnliches Licht oder ein rotes helles und ein weißes helles Licht, das rote Licht 1,00 m über dem weißen; bb) bei Tag: eine Flagge, deren obere Hälfte rot und deren untere Hälfte weiß ist, oder zwei Flaggen übereinander, die obere rot, die untere weiß,"
            },
            {
              "id": "b.2",
              "text": "nach der Seite, an der die Durchfahrt nicht frei ist: aa) bei Nacht: ein rotes Licht in gleicher Höhe und von gleicher Stärke wie das nach Buchstabe a Doppelbuchstabe aa gezeigte rote Licht; bb) bei Tag: eine rote Flagge in gleicher Höhe wie die weiß-rote Flagge oder die rote Flagge auf der anderen Seite."
            }
          ]
        },
        {
          "id": "2",
          "text": "Ein festgefahrenes oder gesunkenes Fahrzeug muss die Bezeichnung nach Nummer 1 Satz 2 Buchstabe a und b führen. Liegt ein gesunkenes Fahrzeug so, dass die Zeichen nicht auf ihm angebracht werden können, müssen sie auf Nachen, Tonnen oder in anderer geeigneter Weise gesetzt werden.",
          "teile": []
        },
        {
          "id": "3",
          "text": "Die zuständige Behörde kann von der Führung der Bezeichnung nach Nummer 1 Satz 1 Buchstabe a und b befreien.",
          "teile": []
        }
      ]
    },
    "3.26": {
      "nummer": "3.26",
      "titel": "Zusätzliche Bezeichnung der Fahrzeuge, Schwimmkörper und schwimmenden Anlagen, deren Anker die Schifffahrt gefährden können, und ihrer Anker",
      "bilder": [
        "Bild 53",
        "54",
        "55"
      ],
      "absaetze": [
        {
          "id": "1",
          "text": "Ein stillliegendes Fahrzeug, dessen Anker so ausgeworfen sind, dass ein Anker, ein Ankerkabel oder eine Ankerkette die Schifffahrt gefährden kann, muss zusätzlich zu der anderen nach dieser Verordnung vorgeschriebenen Bezeichnung bei Nacht führen: ein von allen Seiten sichtbares zusätzliches weißes gewöhnliches Licht 1,00 m unter dem Licht nach § 3.20 Nummer 1 oder, wenn zwei Stillliegelichter gesetzt sind, unter dem Licht, das dem Anker am nächsten liegt.",
          "teile": []
        },
        {
          "id": "2",
          "text": "Wenn in den Fällen des § 3.23 ein Anker so ausgeworfen ist, dass die Schifffahrt gefährdet sein kann, muss das diesem Anker nächstgelegene Licht durch zwei von allen Seiten sichtbare weiße gewöhnliche Lichter, die in einem Abstand von 1,00 m übereinander angebracht sind, ersetzt werden.",
          "teile": []
        },
        {
          "id": "3",
          "text": "In den Fällen der Nummern 1 und 2 ist jeder dieser Anker mit einem gelben Döpper mit Radarreflektor zu bezeichnen.",
          "teile": []
        },
        {
          "id": "4",
          "text": "Wenn ein Anker, ein Ankerkabel oder eine Ankerkette eines schwimmenden Gerätes die Schifffahrt gefährden kann, ist er, es oder sie zu bezeichnen:",
          "teile": [
            {
              "id": "a",
              "text": "bei Nacht: durch eine Tonne mit Radarreflektor und einem von allen Seiten sichtbaren weißen gewöhnlichen Licht;"
            },
            {
              "id": "b",
              "text": "bei Tag: durch einen gelben Döpper mit Radarreflektor."
            }
          ]
        }
      ]
    },
    "3.27": {
      "nummer": "3.27",
      "titel": "Bezeichnung der Fahrzeuge der Überwachungsbehörden",
      "bilder": [
        "Bild 56"
      ],
      "absaetze": [
        {
          "id": "1",
          "text": "Ein Fahrzeug der Überwachungsbehörden nach § 1.20 kann bei Nacht und bei Tag ein blaues Funkellicht zeigen, um sich kenntlich zu machen. Dies gilt auch für ein Fahrzeug der Feuerwehr, ein Wasserrettungsfahrzeug nach § 1.24 Nummer 2 im Rettungseinsatz, ein Fahrzeug des Zivil- und Katastrophenschutzes, ein Fahrzeug der Zollverwaltung, ein Fahrzeug der Bundespolizei oder ein Fahrzeug des Bundeskriminalamtes.",
          "teile": []
        }
      ]
    },
    "3.28": {
      "nummer": "3.28",
      "titel": "Zusätzliche Bezeichnung der Fahrzeuge in Fahrt, die Arbeiten in der Wasserstraße ausführen",
      "bilder": [
        "Bild 57"
      ],
      "absaetze": [
        {
          "id": "1",
          "text": "Ein in Fahrt befindliches Fahrzeug, das in der Wasserstraße Arbeiten, Peilungen oder andere Messungen ausführt, kann mit Erlaubnis der zuständigen Behörde bei Nacht und bei Tag zusätzlich zu der anderen nach dieser Verordnung vorgeschriebenen Bezeichnung führen: ein von allen Seiten sichtbares gelbes gewöhnliches Funkellicht oder ein von allen Seiten sichtbares gelbes helles Funkellicht.",
          "teile": []
        }
      ]
    },
    "3.28a": {
      "nummer": "3.28a",
      "titel": "Bezeichnung und Fahrregeln für Mehrzweckfahrzeuge der Bundeswehr",
      "bilder": [],
      "absaetze": [
        {
          "id": "1",
          "text": "Ein Mehrzweckfahrzeug der Bundeswehr führt während der Fahrt bei Nacht die Lichter nach § 3.08 Nummer 1 und 1,00 m oberhalb des Topplichtes zusätzlich ein von allen Seiten sichtbares gelbes gewöhnliches Funkellicht oder ein von allen Seiten sichtbares gelbes helles Funkellicht, das bei Nacht und bei Tag eingeschaltet sein muss.",
          "teile": []
        },
        {
          "id": "2",
          "text": "Das Fahrzeug nach Nummer 1 verhält sich während der Fahrt grundsätzlich wie ein Kleinfahrzeug. Es gelten die §§ 6.02 und 6.02a Nummer 1 und 4.",
          "teile": []
        }
      ]
    },
    "3.29": {
      "nummer": "3.29",
      "titel": "Schutz gegen Sog und Wellenschlag",
      "bilder": [
        "Bild 58"
      ],
      "absaetze": [
        {
          "id": "1",
          "text": "Ein in Fahrt befindliches oder stillliegendes Fahrzeug, ein in Fahrt befindlicher oder stillliegender Schwimmkörper oder eine in Fahrt befindliche oder stillliegende schwimmende Anlage, das, der oder die gegen Sog und Wellenschlag eines vorbeifahrenden Fahrzeugs oder Schwimmkörpers geschützt werden will, kann zusätzlich zu der anderen nach dieser Verordnung vorgeschriebenen Bezeichnung führen:",
          "teile": [
            {
              "id": "a",
              "text": "bei Nacht: ein rotes gewöhnliches und ein weißes gewöhnliches Licht oder ein rotes helles und ein weißes helles Licht, das rote Licht 1,00 m über dem weißen, an einer Stelle, an der sie gut gesehen und nicht mit anderen Lichtern verwechselt werden können;"
            },
            {
              "id": "b",
              "text": "bei Tag: eine Flagge, deren obere Hälfte rot und deren untere Hälfte weiß ist, an einer geeigneten Stelle und so hoch, dass sie von allen Seiten sichtbar ist. Die Flagge kann durch zwei Flaggen übereinander, die obere rot, die untere weiß, ersetzt werden. Die Flaggen können durch Tafeln gleicher Farbe ersetzt werden."
            }
          ]
        },
        {
          "id": "2",
          "text": "Von der Bezeichnung nach Nummer 1 dürfen nur Gebrauch machen: § 3.25 bleibt unberührt.",
          "teile": [
            {
              "id": "a",
              "text": "ein Fahrzeug, ein Schwimmkörper oder eine schwimmende Anlage, das, der oder die schwer beschädigt ist oder das, der oder die sich an Rettungsarbeiten beteiligt, sowie ein manövrierunfähiges Fahrzeug;"
            },
            {
              "id": "b",
              "text": "ein Fahrzeug, ein Schwimmkörper oder eine schwimmende Anlage mit schriftlicher Erlaubnis der zuständigen Behörde."
            }
          ]
        }
      ]
    },
    "3.30": {
      "nummer": "3.30",
      "titel": "Notzeichen",
      "bilder": [
        "Bild 59"
      ],
      "absaetze": [
        {
          "id": "1",
          "text": "Ein in Not befindliches Fahrzeug, das Hilfe durch Sichtzeichen herbeirufen will, kann zeigen:",
          "teile": [
            {
              "id": "a",
              "text": "bei Nacht: ein Licht, das im Kreis geschwenkt wird;"
            },
            {
              "id": "b",
              "text": "bei Tag: eine rote Flagge, die im Kreis geschwenkt wird, oder einen sonstigen geeigneten Gegenstand, der im Kreis geschwenkt wird."
            }
          ]
        },
        {
          "id": "2",
          "text": "Die Sichtzeichen nach Nummer 1 ersetzen oder ergänzen die Schallzeichen nach § 4.04.",
          "teile": []
        }
      ]
    },
    "3.31": {
      "nummer": "3.31",
      "titel": "Hinweis auf das Verbot, das Fahrzeug zu betreten",
      "bilder": [
        "Bild 60"
      ],
      "absaetze": [
        {
          "id": "1",
          "text": "Sofern es nicht an Bord beschäftigten Personen durch andere Vorschriften verboten ist, das Fahrzeug zu betreten, muss dieses Verbot durch runde weiße Tafeln mit rotem Rand, rotem Schrägstrich und angezeigt werden. Die Tafeln sind je nach Bedarf an Bord oder am Laufsteg aufzustellen. Abweichend von § 3.03 Nummer 3 muss ihr Durchmesser mindestens 0,60 m betragen.",
          "teile": [
            {
              "id": "a",
              "text": "einem schwarzen Sinnbild des Fußgängers oder"
            },
            {
              "id": "b",
              "text": "einem schwarzen Sinnbild einer rufenden Person, die eine Hand abwehrend hochhält,"
            }
          ]
        },
        {
          "id": "2",
          "text": "Die Tafeln müssen erforderlichenfalls beleuchtet werden, damit sie bei Nacht deutlich sichtbar sind.",
          "teile": []
        }
      ]
    },
    "3.32": {
      "nummer": "3.32",
      "titel": "Hinweis auf das Verbot zu rauchen, ungeschütztes Licht oder Feuer zu verwenden",
      "bilder": [
        "Bild 61"
      ],
      "absaetze": [
        {
          "id": "1",
          "text": "Sofern es durch andere Vorschriften verboten ist, an Bord muss dieses Verbot durch runde weiße Tafeln mit rotem Rand und rotem Schrägstrich, auf denen abgebildet ist, angezeigt werden. Die Tafeln sind je nach Bedarf an Bord oder am Laufsteg aufzustellen. Abweichend von § 3.03 Nummer 3 muss ihr Durchmesser mindestens 0,60 m betragen.",
          "teile": [
            {
              "id": "a",
              "text": "zu rauchen,"
            },
            {
              "id": "b",
              "text": "ungeschütztes Licht oder Feuer zu verwenden,"
            },
            {
              "id": "a.2",
              "text": "eine brennende Zigarette in schwarzer Farbe oder"
            },
            {
              "id": "b.2",
              "text": "ein entzündetes Streichholz in schwarzer Farbe"
            }
          ]
        },
        {
          "id": "2",
          "text": "Die Tafeln müssen erforderlichenfalls beleuchtet werden, damit sie bei Nacht deutlich sichtbar sind.",
          "teile": []
        }
      ]
    },
    "3.33": {
      "nummer": "3.33",
      "titel": "Hinweis auf das Verbot des Stillliegens nebeneinander",
      "bilder": [
        "Bild 62"
      ],
      "absaetze": [
        {
          "id": "1",
          "text": "Sofern das seitliche Stillliegen in der Nähe eines Fahrzeugs durch andere Vorschriften oder durch besondere Anforderungen der zuständigen Behörde verboten ist, muss dieses Fahrzeug an Deck in der Längsachse eine quadratische Tafel, darunter ein dreieckiges Zusatzschild führen. Die quadratische Tafel ist auf beiden Seiten weiß mit rotem Rand und trägt einen roten Schrägstrich von links oben nach rechts unten und ein schwarzes „P“ im Mittelfeld. Das dreieckige Zusatzschild ist auf beiden Seiten weiß und zeigt in schwarzen Zahlen die Entfernung in Metern an, innerhalb derer das Stillliegen verboten ist.",
          "teile": []
        },
        {
          "id": "2",
          "text": "Bei Nacht müssen die Tafeln so beleuchtet sein, dass sie an beiden Seiten des Fahrzeugs deutlich sichtbar sind.",
          "teile": []
        },
        {
          "id": "3",
          "text": "Dieser Paragraf gilt nicht für die in § 3.21 genannten Fahrzeuge, Schubverbände oder gekuppelten Fahrzeuge.",
          "teile": []
        }
      ]
    },
    "3.34": {
      "nummer": "3.34",
      "titel": "Verhaltenspflichten",
      "bilder": [],
      "absaetze": [
        {
          "id": "1",
          "text": "Der Schiffsführer und die nach § 1.03 Nummer 3 für Kurs und Geschwindigkeit verantwortliche Person haben jeweils sicherzustellen, dass in den Fällen des § 3.01 Nummer 2 die für die Nacht vorgeschriebenen Lichter zusätzlich auch bei Tag gesetzt werden.",
          "teile": []
        },
        {
          "id": "2",
          "text": "Der Schiffsführer und die nach § 1.03 Nummer 3 für Kurs und Geschwindigkeit verantwortliche Person haben jeweils sicherzustellen, dass auf dem Fahrzeug, dem Verband, dem Vorspann, dem Schwimmkörper oder der schwimmenden Anlage die in § 3.08 Nummer 1, auch in Verbindung mit Nummer 2 und 3, und Nummer 4 und mit § 3.28a Nummer 1, § 3.11 Nummer 1, auch in Verbindung mit Nummer 2, und Nummer 3, § 3.12 Nummer 1, § 3.15 Satz 1, §§ 3.17, 3.18 Nummer 1 Satz 1 und § 3.19 jeweils vorgeschriebene Bezeichnung während der Fahrt geführt wird.",
          "teile": []
        },
        {
          "id": "3",
          "text": "Der Schiffsführer und die nach § 1.03 Nummer 3 für Kurs und Geschwindigkeit verantwortliche Person haben jeweils sicherzustellen, dass auf dem Fahrzeug, dem Verband, dem Vorspann, dem Schwimmkörper oder der schwimmenden Anlage in den in § 3.09 Nummer 1 bis 4, § 3.10 Nummer 1 bis 4, § 3.13 Nummer 1 bis 6, § 3.14 Nummer 1 bis 7, jeweils auch in Verbindung mit Nummer 8, und § 3.16 Nummer 1 bis 3 genannten Fällen die dort jeweils vorgeschriebene Bezeichnung während der Fahrt geführt wird.",
          "teile": []
        },
        {
          "id": "4",
          "text": "Der Schiffsführer darf das Fahrzeug nur führen, wenn",
          "teile": [
            {
              "id": "a",
              "text": "dessen Lichter gemäß § 3.02 Nummer 1 von allen Seiten sichtbar sind und ein gleichmäßiges, ununterbrochenes Licht werfen,"
            },
            {
              "id": "b",
              "text": "dessen Signalleuchten den in § 3.02 Nummer 2 Satz 1 genannten Vorschriften entsprechen,"
            },
            {
              "id": "c",
              "text": "dessen Nachtbezeichnung die Tragweite nach § 3.02 Nummer 3 hat."
            }
          ]
        },
        {
          "id": "5",
          "text": "Der Schiffsführer hat sicherzustellen, dass die auf dem Fahrzeug verwendeten",
          "teile": [
            {
              "id": "a",
              "text": "Flaggen, Tafeln und Wimpel den Anforderungen nach § 3.03 Nummer 1 bis 3, § 3.31 Nummer 1 Satz 3 und § 3.32 Nummer 1 Satz 3 entsprechen und"
            },
            {
              "id": "b",
              "text": "Zylinder, Bälle und Kegel den Anforderungen nach § 3.04 Nummer 2 und 3 entsprechen."
            }
          ]
        },
        {
          "id": "6",
          "text": "Der Schiffsführer hat sicherzustellen, dass auf dem Fahrzeug oder dem Verband in den in § 3.20 Nummer 1 und 2, § 3.21 in Verbindung mit § 3.14 Nummer 1 bis 7, § 3.22 Nummer 1 und 2 Satz 1, § 3.24 Nummer 1 und 2, § 3.25 Nummer 1 und 2 und § 3.26 Nummer 1 genannten Fällen die dort jeweils vorgeschriebene Bezeichnung während des Stillliegens geführt wird.",
          "teile": []
        },
        {
          "id": "7",
          "text": "Der Schiffsführer hat sicherzustellen, dass ein ausgeworfener Anker des Fahrzeugs während des Stillliegens in dem in § 3.26 Nummer 1 genannten Fall nach § 3.26 Nummer 3 bezeichnet ist.",
          "teile": []
        },
        {
          "id": "8",
          "text": "Der Schiffsführer hat sicherzustellen, dass in dem in § 3.22 Nummer 2 Satz 2 genannten Fall die dort genannte Bezeichnung gelöscht ist.",
          "teile": []
        },
        {
          "id": "9",
          "text": "Der Schiffsführer hat sicherzustellen, dass auf dem Fahrzeug auf das Verbot in der jeweils vorgeschriebenen Weise hingewiesen wird.",
          "teile": [
            {
              "id": "a",
              "text": "des Betretens nach § 3.31 Nummer 1, auch in Verbindung mit Nummer 2,"
            },
            {
              "id": "b",
              "text": "zu rauchen und ungeschütztes Licht oder Feuer zu verwenden nach § 3.32 Nummer 1, auch in Verbindung mit Nummer 2, und"
            },
            {
              "id": "c",
              "text": "des Stillliegens seitlich nebeneinander nach § 3.33 Nummer 1, auch in Verbindung mit Nummer 2,"
            }
          ]
        },
        {
          "id": "10",
          "text": "Der Schiffsführer, Eigentümer und Ausrüster haben jeweils sicherzustellen, dass auf dem Schwimmkörper oder der schwimmenden Anlage bei Nacht beim Stillliegen die in § 3.23 Satz 1 vorgeschriebene Bezeichnung geführt wird.",
          "teile": []
        },
        {
          "id": "11",
          "text": "Der Schiffsführer, Eigentümer und Ausrüster haben jeweils sicherzustellen, dass auf dem Schwimmkörper oder der schwimmenden Anlage bei Nacht beim Stillliegen in dem in § 3.26 Nummer 2 genannten Fall die dort vorgeschriebene Bezeichnung geführt wird.",
          "teile": []
        },
        {
          "id": "12",
          "text": "Der Schiffsführer, Eigentümer und Ausrüster haben jeweils sicherzustellen, dass ein ausgeworfener Anker des oder der bei Nacht stillliegenden Schwimmkörpers oder schwimmenden Anlage in dem in § 3.26 Nummer 2 genannten Fall nach § 3.26 Nummer 3 bezeichnet ist.",
          "teile": []
        },
        {
          "id": "13",
          "text": "Der Schiffsführer, Eigentümer und Ausrüster haben jeweils sicherzustellen, dass ein Anker, ein Ankerkabel oder eine Ankerkette des schwimmenden Gerätes, der, das oder die die Schifffahrt gefährden kann, nach § 3.26 Nummer 4 bezeichnet ist.",
          "teile": []
        },
        {
          "id": "14",
          "text": "Der Eigentümer und der Ausrüster dürfen jeweils die Inbetriebnahme eines Fahrzeugs oder eines Verbandes nur anordnen oder zulassen, wenn",
          "teile": [
            {
              "id": "a",
              "text": "dessen Lichter nach § 3.02 Nummer 1 von allen Seiten sichtbar sind und ein gleichmäßiges, ununterbrochenes Licht werfen,"
            },
            {
              "id": "b",
              "text": "dessen Signalleuchten den in § 3.02 Nummer 2 genannten Vorschriften entsprechen,"
            },
            {
              "id": "c",
              "text": "dessen Nachtbezeichnung die nach § 3.02 Nummer 3 Halbsatz 2 vorgeschriebene Tragweite hat."
            }
          ]
        }
      ]
    },
    "4.01": {
      "nummer": "4.01",
      "titel": "Allgemeines",
      "bilder": [],
      "absaetze": [
        {
          "id": "1",
          "text": "Soweit in dieser Verordnung das Geben eines Schallzeichens und nicht die Verwendung der Glocke vorgeschrieben ist, muss es wie folgt gegeben werden:",
          "teile": [
            {
              "id": "a",
              "text": "auf einem Fahrzeug mit Maschinenantrieb, ausgenommen einem Kleinfahrzeug, mittels eines mechanisch betriebenen Schallgerätes, das genügend hoch angebracht ist, dass sich der Schall nach vorn und möglichst auch nach achtern frei ausbreiten kann;"
            },
            {
              "id": "b",
              "text": "auf einem Fahrzeug ohne Maschinenantrieb und auf einem Kleinfahrzeug mittels eines Schallgerätes, einer geeigneten Hupe oder eines geeigneten Horns."
            }
          ]
        },
        {
          "id": "2",
          "text": "Auf einem Fahrzeug mit Maschinenantrieb muss gleichzeitig mit einem Schallzeichen ein gleich langes Lichtzeichen gegeben werden, das gelb, hell und von allen Seiten sichtbar sein muss. Dies gilt nicht für ein Kleinfahrzeug sowie für Glockenzeichen.",
          "teile": []
        },
        {
          "id": "3",
          "text": "Fahren Fahrzeuge in einem Verband, ist ein vorgeschriebenes Schallzeichen nur von dem Fahrzeug zu geben, auf dem sich der Führer des Verbandes befindet, bei einem Schleppverband von dem motorisierten Fahrzeug an der Spitze des Verbandes.",
          "teile": []
        },
        {
          "id": "4",
          "text": "Eine Gruppe von Glockenschlägen muss etwa vier Sekunden dauern. Sie kann durch Schläge von Metall auf Metall gleicher Dauer ersetzt werden.",
          "teile": []
        },
        {
          "id": "5",
          "text": "Der Schiffsführer und die nach § 1.03 Nummer 3 für Kurs und Geschwindigkeit verantwortliche Person müssen jeweils sicherstellen, dass ein vorgeschriebenes Schallzeichen in der in den Nummern 1, 2 Satz 1 und Nummer 4, jeweils auch in Verbindung mit Nummer 3, vorgeschriebenen Art und Weise abgegeben wird.",
          "teile": []
        }
      ]
    },
    "4.02": {
      "nummer": "4.02",
      "titel": "Gebrauch der Schallzeichen",
      "bilder": [],
      "absaetze": [
        {
          "id": "1",
          "text": "Vorbehaltlich anderer Bestimmungen dieser Verordnung muss jedes Fahrzeug – mit Ausnahme eines Kleinfahrzeugs – in den in Anlage 6 genannten Fällen die dort jeweils genannten Schallzeichen geben.",
          "teile": []
        },
        {
          "id": "2",
          "text": "Ein Kleinfahrzeug kann erforderlichenfalls die allgemeinen Schallzeichen nach Abschnitt A der Anlage 6 geben.",
          "teile": []
        },
        {
          "id": "3",
          "text": "Der Schiffsführer und die nach § 1.03 Nummer 3 für Kurs und Geschwindigkeit verantwortliche Person müssen jeweils sicherstellen, dass nach Nummer 1 vorgeschriebene Schallzeichen gegeben werden.",
          "teile": []
        }
      ]
    },
    "4.03": {
      "nummer": "4.03",
      "titel": "Verbotene Schallzeichen",
      "bilder": [],
      "absaetze": [
        {
          "id": "1",
          "text": "Es darf kein anderes als die in dieser Verordnung vorgesehenen Schallzeichen gebraucht oder unter Umständen gebraucht werden, für die es durch diese Verordnung nicht vorgeschrieben oder zugelassen ist.",
          "teile": []
        },
        {
          "id": "2",
          "text": "Zur Verständigung von Fahrzeug zu Fahrzeug und zwischen Fahrzeug und Land darf jedoch auch ein anderes Schallzeichen verwendet werden, sofern dies zu keiner Verwechslung mit den in dieser Verordnung vorgesehenen Schallzeichen führen kann.",
          "teile": []
        }
      ]
    },
    "4.04": {
      "nummer": "4.04",
      "titel": "Notzeichen",
      "bilder": [],
      "absaetze": [
        {
          "id": "1",
          "text": "Ein Fahrzeug, das Hilfe durch ein Schallzeichen herbeirufen will, insbesondere, wenn das Fahrzeug in Not oder ein Mensch über Bord gefallen ist, kann entweder mit der Glocke läuten oder lange Töne wiederholt abgeben.",
          "teile": []
        },
        {
          "id": "2",
          "text": "Diese Schallzeichen ersetzen oder ergänzen die Sichtzeichen nach § 3.30.",
          "teile": []
        }
      ]
    }
  },
  "anlage6": {
    "titel": "Schallzeichen",
    "vorbemerkung": "Die Schallzeichen, ausgenommen die Glockenschläge, bestehen in der Abgabe eines Tones oder mehrerer Töne hintereinander mit folgenden Merkmalen: – kurzer Ton: ein Ton von etwa einer Sekunde Dauer; – langer Ton: ein Ton von etwa vier Sekunden Dauer. Die Pause zwischen zwei aufeinanderfolgenden Tönen beträgt etwa eine Sekunde. Jedoch besteht das Zeichen „Folge von sehr kurzen Tönen“ aus einer Folge von mindestens sechs Tönen je von etwa einer Viertelsekunde Dauer, wobei die Pause zwischen den Tönen ebenso lang ist. Eine Gruppe von Glockenschlägen muss etwa vier Sekunden dauern. Sie kann durch Schläge von Metall auf Metall gleicher Dauer ersetzt werden.",
    "abschnitte": [
      {
        "buchstabe": "A",
        "titel": "Allgemeine Zeichen"
      },
      {
        "buchstabe": "B",
        "titel": "Begegnungszeichen"
      },
      {
        "buchstabe": "C",
        "titel": "Überholzeichen"
      },
      {
        "buchstabe": "D",
        "titel": "Wendezeichen"
      },
      {
        "buchstabe": "E",
        "titel": "Zeichen bei der Einfahrt in und der Ausfahrt aus Häfen und Nebenwasserstraßen"
      },
      {
        "buchstabe": "F",
        "titel": "(ohne Inhalt)"
      },
      {
        "buchstabe": "G",
        "titel": "Zeichen bei unsichtigem Wetter"
      }
    ],
    "eintraege": [
      {
        "abschnitt": "A",
        "beschreibung": "1 langer Ton",
        "bedeutung": "Achtung"
      },
      {
        "abschnitt": "A",
        "beschreibung": "1 kurzer Ton",
        "bedeutung": "Ich richte meinen Kurs nach Steuerbord"
      },
      {
        "abschnitt": "A",
        "beschreibung": "2 kurze Töne",
        "bedeutung": "Ich richte meinen Kurs nach Backbord"
      },
      {
        "abschnitt": "A",
        "beschreibung": "3 kurze Töne",
        "bedeutung": "Meine Maschine geht rückwärts"
      },
      {
        "abschnitt": "A",
        "beschreibung": "4 kurze Töne",
        "bedeutung": "Ich bin manövrierunfähig"
      },
      {
        "abschnitt": "A",
        "beschreibung": "Folge sehr kurzer Töne",
        "bedeutung": "Gefahr eines Zusammenstoßes"
      },
      {
        "abschnitt": "A",
        "beschreibung": "Wiederholte lange Töne",
        "bedeutung": "Notsignal",
        "fundstelle": "§ 4.04 Nummer 1"
      },
      {
        "abschnitt": "A",
        "beschreibung": "Gruppe von Glockenschlägen",
        "bedeutung": "Notsignal",
        "fundstelle": "§ 4.04 Nummer 1"
      },
      {
        "abschnitt": "A",
        "beschreibung": "Mindestens 15 Minuten lang ununterbrochene Wiederholung abwechselnd eines kurzen und eines langen Tones in Verbindung mit dem Lichtzeichen nach § 4.01 Nummer 2",
        "bedeutung": "Bleib-Weg-Signal",
        "fundstelle": "§ 8.09 Nummer 2 in Verbindung mit Nummer 1"
      },
      {
        "abschnitt": "B",
        "lage": "Vorbeifahrt an Backbord verlangt",
        "fall": "Normalfall",
        "beschreibung": "1 kurzer Ton",
        "bedeutung": "Ich will an Backbord vorbeifahren",
        "wer": "des Bergfahrers",
        "fundstelle": "§ 6.04 Nummer 4 Buchstabe a"
      },
      {
        "abschnitt": "B",
        "lage": "Vorbeifahrt an Backbord verlangt",
        "fall": "Normalfall",
        "beschreibung": "1 kurzer Ton",
        "bedeutung": "Einverstanden, fahren Sie an Backbord vorbei",
        "wer": "des Talfahrers",
        "fundstelle": "§ 6.04 Nummer 5"
      },
      {
        "abschnitt": "B",
        "lage": "Vorbeifahrt an Backbord verlangt",
        "fall": "Abweichung",
        "beschreibung": "2 kurze Töne",
        "bedeutung": "Nicht einverstanden, fahren Sie an Steuerbord vorbei",
        "wer": "des Talfahrers",
        "fundstelle": "§ 6.05 Nummer 2 Buchstabe b"
      },
      {
        "abschnitt": "B",
        "lage": "Vorbeifahrt an Backbord verlangt",
        "fall": "Abweichung",
        "beschreibung": "2 kurze Töne",
        "bedeutung": "Einverstanden, ich werde an Steuerbord vorbeifahren",
        "wer": "des Bergfahrers",
        "fundstelle": "§ 6.05 Nummer 3 Buchstabe b"
      },
      {
        "abschnitt": "B",
        "lage": "Vorbeifahrt an Steuerbord verlangt",
        "fall": "Normalfall",
        "beschreibung": "2 kurze Töne",
        "bedeutung": "Ich will an Steuerbord vorbeifahren",
        "wer": "des Bergfahrers",
        "fundstelle": "§ 6.04 Nummer 4 Buchstabe b"
      },
      {
        "abschnitt": "B",
        "lage": "Vorbeifahrt an Steuerbord verlangt",
        "fall": "Normalfall",
        "beschreibung": "2 kurze Töne",
        "bedeutung": "Einverstanden, fahren Sie an Steuerbord vorbei",
        "wer": "des Talfahrers",
        "fundstelle": "§ 6.04 Nummer 5"
      },
      {
        "abschnitt": "B",
        "lage": "Vorbeifahrt an Steuerbord verlangt",
        "fall": "Abweichung",
        "beschreibung": "1 kurzer Ton",
        "bedeutung": "Nicht einverstanden, fahren Sie an Backbord vorbei",
        "wer": "des Talfahrers",
        "fundstelle": "§ 6.05 Nummer 2 Buchstabe a"
      },
      {
        "abschnitt": "B",
        "lage": "Vorbeifahrt an Steuerbord verlangt",
        "fall": "Abweichung",
        "beschreibung": "1 kurzer Ton",
        "bedeutung": "Einverstanden, ich werde an Backbord vorbeifahren",
        "wer": "des Bergfahrers",
        "fundstelle": "§ 6.05 Nummer 3 Buchstabe a"
      },
      {
        "abschnitt": "C",
        "lage": "Überholen an Backbord des Vorausfahrenden verlangt",
        "beschreibung": "2 lange Töne, 2 kurze Töne",
        "bedeutung": "Ich will auf Ihrer Backbordseite überholen",
        "fundstelle": "§ 6.10 Nummer 2 Buchstabe a",
        "wer": "des Überholenden"
      },
      {
        "abschnitt": "C",
        "lage": "Überholen an Backbord des Vorausfahrenden verlangt",
        "fall": "Normalfall",
        "beschreibung": "Kein Zeichen",
        "bedeutung": "Einverstanden, Sie können auf meiner Backbordseite überholen",
        "wer": "des Vorausfahrenden",
        "fundstelle": "§ 6.10 Nummer 3"
      },
      {
        "abschnitt": "C",
        "lage": "Überholen an Backbord des Vorausfahrenden verlangt",
        "fall": "Abweichung",
        "beschreibung": "2 kurze Töne",
        "bedeutung": "Nicht einverstanden, überholen Sie auf meiner Steuerbordseite",
        "wer": "des Vorausfahrenden",
        "fundstelle": "§ 6.10 Nummer 4 Satz 1 Buchstabe b"
      },
      {
        "abschnitt": "C",
        "lage": "Überholen an Backbord des Vorausfahrenden verlangt",
        "fall": "Abweichung",
        "beschreibung": "1 kurzer Ton",
        "bedeutung": "Einverstanden, ich werde auf Ihrer Steuerbordseite überholen",
        "wer": "des Überholenden",
        "fundstelle": "§ 6.10 Nummer 4 Satz 2 Buchstabe b"
      },
      {
        "abschnitt": "C",
        "lage": "Überholen an Steuerbord des Vorausfahrenden verlangt",
        "beschreibung": "2 lange Töne, 1 kurzer Ton",
        "bedeutung": "Ich will auf Ihrer Steuerbordseite überholen",
        "fundstelle": "§ 6.10 Nummer 2 Buchstabe b",
        "wer": "des Überholenden"
      },
      {
        "abschnitt": "C",
        "lage": "Überholen an Steuerbord des Vorausfahrenden verlangt",
        "fall": "Normalfall",
        "beschreibung": "Kein Schallzeichen",
        "bedeutung": "Einverstanden, Sie können auf meiner Steuerbordseite überholen",
        "wer": "des Vorausfahrenden",
        "fundstelle": "§ 6.10 Nummer 3"
      },
      {
        "abschnitt": "C",
        "lage": "Überholen an Steuerbord des Vorausfahrenden verlangt",
        "fall": "Abweichung",
        "beschreibung": "1 kurzer Ton",
        "bedeutung": "Nicht einverstanden, überholen Sie auf meiner Backbordseite",
        "wer": "des Vorausfahrenden",
        "fundstelle": "§ 6.10 Nummer 4 Satz 1 Buchstabe a"
      },
      {
        "abschnitt": "C",
        "lage": "Überholen an Steuerbord des Vorausfahrenden verlangt",
        "fall": "Abweichung",
        "beschreibung": "2 kurze Töne",
        "bedeutung": "Einverstanden, ich werde auf Ihrer Backbordseite überholen",
        "wer": "des Überholenden",
        "fundstelle": "§ 6.10 Nummer 4 Satz 2 Buchstabe a"
      },
      {
        "abschnitt": "C",
        "lage": "Unmöglichkeit des Überholens",
        "beschreibung": "5 kurze Töne",
        "bedeutung": "Man kann mich nicht überholen",
        "wer": "des Vorausfahrenden",
        "fundstelle": "§ 6.10 Nummer 5"
      },
      {
        "abschnitt": "D",
        "beschreibung": "1 langer Ton, 1 kurzer Ton",
        "bedeutung": "Ich wende über Steuerbord",
        "fundstelle": "§ 6.13 Nummer 2 Buchstabe a, § 6.16 Nummer 2 Buchstabe c Doppelbuchstabe aa"
      },
      {
        "abschnitt": "D",
        "beschreibung": "1 langer Ton, 2 kurze Töne",
        "bedeutung": "Ich wende über Backbord",
        "fundstelle": "§ 6.13 Nummer 2 Buchstabe b, § 6.16 Nummer 2 Buchstabe c Doppelbuchstabe bb"
      },
      {
        "abschnitt": "E",
        "beschreibung": "3 lange Töne, 1 kurzer Ton",
        "bedeutung": "Ich will meinen Kurs nach Steuerbord richten",
        "fundstelle": "§ 6.16 Nummer 2 Satz 1 Buchstabe a"
      },
      {
        "abschnitt": "E",
        "beschreibung": "3 lange Töne, 2 kurze Töne",
        "bedeutung": "Ich will meinen Kurs nach Backbord richten",
        "fundstelle": "§ 6.16 Nummer 2 Satz 1 Buchstabe b"
      },
      {
        "abschnitt": "E",
        "beschreibung": "3 lange Töne",
        "bedeutung": "Ich will überqueren",
        "fundstelle": "§ 6.16 Nummer 2 Satz 1 Buchstabe c"
      },
      {
        "abschnitt": "G",
        "lage": "Einzeln fahrendes Fahrzeug und Verband, das oder der kein Radar benutzt",
        "beschreibung": "1 langer Ton, längstens jede Minute wiederholt",
        "fundstelle": "§ 6.33 Nummer 2 Satz 1, § 6.34 Nummer 3, auch in Verbindung mit Nummer 8 Satz 1"
      },
      {
        "abschnitt": "G",
        "lage": "Fahrzeug in der Radarfahrt, wenn kein Sprechfunkkontakt zustande kommt",
        "beschreibung": "1 langer Ton, wiederholt",
        "fundstelle": "§ 6.32 Nummer 2 Buchstabe d Doppelbuchstabe aa"
      },
      {
        "abschnitt": "G",
        "lage": "Stillliegendes Fahrzeug",
        "beschreibung": "1 Gruppe von Glockenschlägen, längstens jede Minute wiederholt",
        "fundstelle": "§ 6.31 Nummer 2, auch in Verbindung mit Nummer 3 Satz 2"
      }
    ]
  }
}
